import Cookies from 'universal-cookie'

const cookies = new Cookies()

export const getCookie = name => cookies.get(name)

export const removeCookie = name => cookies.remove(name, { path: '/', domain: '.lelivrescolaire.fr' })
